export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-img1-e31cb0494a8af85835397b7448d06a98.jpg";